import React, { useContext, useEffect, useState } from 'react'
import { BreadcrumbContext } from '../components/Breadcrumb';

export default function useBreadcrumb() {
    const [state, dispatch] = useContext(BreadcrumbContext);
    
    function setBreadcrumb(payload) {
        dispatch({type: 'SET_BREADCRUMB', payload})
    }
    
    function clearBreadcrumb(payload) {
        dispatch({type: 'SET_BREADCRUMB', payload: {links: [], title: ''}})
    }

    return {setBreadcrumb, clearBreadcrumb}
}
